import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IotProtectIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#6568cd' : this.getColor()
        return [
            <g>
                <path fill={color} d="M2,10.82V25.18a3.79,3.79,0,0,0,1.92,3.26l12,7a4.13,4.13,0,0,0,4.16,0l12-7A3.79,3.79,0,0,0,34,25.18V10.82a3.79,3.79,0,0,0-1.92-3.26l-12-7a4.13,4.13,0,0,0-4.16,0l-12,7A3.79,3.79,0,0,0,2,10.82Z" />
                <path fill={'#fff'} d="M18,6.65A1.55,1.55,0,1,1,16.45,8.2,1.56,1.56,0,0,1,18,6.65m0-1.5a3,3,0,1,0,3.05,3,3.06,3.06,0,0,0-3.05-3Z" />
                <path fill={'#fff'} d="M9.3,23.15A1.55,1.55,0,1,1,7.75,24.7,1.56,1.56,0,0,1,9.3,23.15m0-1.5a3.05,3.05,0,1,0,3,3.05,3.06,3.06,0,0,0-3-3.05Z" />
                <path fill={'#fff'} d="M26.5,23.15A1.55,1.55,0,1,1,25,24.7a1.56,1.56,0,0,1,1.55-1.55m0-1.5a3.05,3.05,0,1,0,3.05,3.05,3.06,3.06,0,0,0-3.05-3.05Z" />
                <circle fill={'#fff'} cx="18" cy="29.2" r="2" />
                <circle fill={'#fff'} cx="29.05" cy="13.55" r="2" />
                <circle fill={'#fff'} cx="7.85" cy="13.55" r="2" />
                <path fill={'#fff'} d="M18.05,26.25a1,1,0,0,1-1-1V13.15a1,1,0,0,1,2,0v12.1A1,1,0,0,1,18.05,26.25Z" />
                <path fill={'#fff'} d="M22.18,23a1,1,0,0,1-.49-.13L10.76,16.72a1,1,0,0,1,1-1.74l10.93,6.19a1,1,0,0,1,.38,1.37A1,1,0,0,1,22.18,23Z" />
                <path fill={'#fff'} d="M13.92,23a1,1,0,0,1-.87-.51,1,1,0,0,1,.38-1.36L25,14.68a1,1,0,1,1,1,1.74L14.41,22.91A1,1,0,0,1,13.92,23Z" />
                <circle fill={'#fff'} cx="18.15" cy="19.25" r="2.85" />
                <path fill={color} d="M18.15,16.9a2.35,2.35,0,1,1-2.35,2.35,2.35,2.35,0,0,1,2.35-2.35m0-1a3.35,3.35,0,1,0,3.35,3.35,3.35,3.35,0,0,0-3.35-3.35Z" />
            </g>]

    }
    getViewBox = () => '0 0 36 36'
}
